export default "__VITE_ASSET__6Rhw3LTQ__"